module.exports = __webpack_public_path__ + "img/transfer23.7c38d379.jpeg";